import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { MenuItem, ROOT_PRODUCTS_KEY, sendClickOnMenuEvent } from '../MenuUtils';
import { SortType } from '../MenuUtils';
import { DEFAULT_PANEL_MENU_INDEX } from '../MenuUtils';
import loadable from '@loadable/component';
import MenuFirstPanel from './MenuFirstPanel';
import { List } from 'react-content-loader';

const MenuListPanel = loadable(() => import('./MenuListPanel'), { fallback: <List height={100} /> });
const MenuCatalogPanel = loadable(() => import('./MenuCatalogPanel'), { fallback: <List height={100} /> });

export interface MenuContentProps {
  show: boolean;
  rootMenuItems: MenuItem[];
  closeMenu: () => void;
  menuSelectedPath: MenuItem[];
  setMenuSelectedPath: (menuItems: MenuItem[]) => void;
  sorting: SortType;
  setSorting: (sortType: SortType) => void;
  productsDisplayMode: DisplayMode;
  setProductsDisplayMode: (displayMode: DisplayMode) => void;
  thematicsFilter: string;
  setThematicsFilter: (filter: string) => void;
  isMinimalistHeader: boolean;
}

export enum DisplayMode {
  list,
  catalog
}

export const DESKTOP_MENU_PANEL_WIDTH = 300; // in px

export const MenuDesktopContent: FunctionComponent<MenuContentProps> = ({
  show,
  rootMenuItems,
  menuSelectedPath,
  setMenuSelectedPath,
  closeMenu,
  sorting,
  setSorting,
  productsDisplayMode,
  setProductsDisplayMode,
  setThematicsFilter,
  thematicsFilter,
  isMinimalistHeader
}) => {
  const selectedTopItem = menuSelectedPath[0];
  const selectedSubItems = menuSelectedPath.slice(1);
  if (show) {
    MenuListPanel.load();
    MenuCatalogPanel.load();
  }

  const onPanelClick = (index: number, label: string) => {
    sendClickOnMenuEvent({ index, label });
  };

  return (
    <>
      {show && <Overlay onClick={closeMenu} />}
      {/* Level 0 and 1 are displayed in MenuTopPanel*/}
      <MenuFirstPanel
        onClick={label => onPanelClick(DEFAULT_PANEL_MENU_INDEX, label)}
        show={show}
        rootMenuItems={rootMenuItems}
        menuSelectedPath={menuSelectedPath}
        setMenuSelectedPath={setMenuSelectedPath}
        setProductsDisplayMode={setProductsDisplayMode}
        productsDisplayMode={productsDisplayMode}
        setSorting={setSorting}
        sorting={sorting}
        closeMenu={closeMenu}
        setThematicsFilter={setThematicsFilter}
        thematicsFilter={thematicsFilter}
        isMinimalistHeader={isMinimalistHeader}
      />
      {/* Levels above are represented in distinct Panels*/}
      {productsDisplayMode === DisplayMode.list &&
        selectedSubItems.map((item, index) => (
          <MenuListPanel
            onClick={(index, label) => onPanelClick(index, label)}
            key={`selectedSubItem_${index}`}
            item={item}
            currentMenuPath={[selectedTopItem, ...selectedSubItems.slice(0, index + 1)]}
            menuSelectedPath={menuSelectedPath}
            setMenuSelectedPath={setMenuSelectedPath}
            panelNumber={index + 1}
            closeMenu={closeMenu}
          />
        ))}
      {productsDisplayMode === DisplayMode.catalog && selectedTopItem?.key === ROOT_PRODUCTS_KEY && show && (
        <MenuCatalogPanel
          items={selectedSubItems[selectedSubItems.length - 1] || rootMenuItems[rootMenuItems.findIndex(item => item.key === ROOT_PRODUCTS_KEY)]}
          menuSelectedPath={menuSelectedPath}
          currentMenuPath={[selectedTopItem]}
          setMenuSelectedPath={setMenuSelectedPath}
          closeMenu={closeMenu}
          onClick={(label: string) => onPanelClick(DEFAULT_PANEL_MENU_INDEX + 1, label)}
        />
      )}
    </>
  );
};

const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(12, 0, 100, 0.5);
  z-index: 11000;
  cursor: pointer;
`;
export default MenuDesktopContent;
